import { get, post } from '../../../service/httpServer.js'
//获取用户信息
export const getAccount = async params => {
  let result = await get('/ecoSystem/api/v1/account/load-info-by-accountId', params)
  return result.data
}
/**
 * 切换企业
 * @param params
 * @returns {Promise<any>}
 */
export const companySwitch = async params => {
  let result = await post('/userCenter/newcoreorg/company/switchingCompany', params)
  return result.data
}
//退出登录
export const logOut = async () => {
  let result = await get('/ecoSystem/home/logout')
  return result.data
}
